import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  NgZone, OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';

import {Homonym} from '../../shared/models/homonym.model';
import {animationFrameScheduler} from "rxjs";


@Component({
  selector: 'app-homonym2-list-item',
  template: `
    <a class="item-box">
      <div class="item-list {{ full ? 'full' : '' }}">
        <div class="item"
             #wordBox
             *ngFor="let word of homonym.listWord">
          <app-homonym-disp [word]="word"></app-homonym-disp>
          <app-homonym-word-play-btn [word]="word"></app-homonym-word-play-btn>
        </div>
      </div>
      <div class="item-menu">
        <app-homonym-all-play-btn [homonym]="homonym"></app-homonym-all-play-btn>
      </div>
    </a>
  `,
})
export class Homonym2ListItemComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @ViewChildren('wordBox') listWordBox: QueryList<ElementRef>;
  @Input() homonym: Homonym;

  private _full = false;
  public get full(): boolean {
    return this._full;
  }


  constructor(
    public eRef: ElementRef,
    private zone: NgZone,
  ) {
  }

  ngAfterViewInit(): void {
    /**
     * 외부에 Event로 초기화를 알리면, 컴포넌트를 세로 2줄로 할 지 세로 1줄로 할지, 외부에서 CSS를 설정해서 변경한다.
     */

    animationFrameScheduler.schedule(() => {
      this.listWordBox.forEach((elWord: ElementRef) => {
        let child = elWord.nativeElement.firstChild;
        let totalWidth = 0;

        while (child) {
          totalWidth += child.offsetWidth;
          child = child.nextSibling;
        }

        const padding = 20;
        // console.warn('totalWidth', totalWidth, elWord.nativeElement.offsetWidth, totalWidth + padding, this.homonym.listWord.length)

        if (elWord.nativeElement.offsetWidth < totalWidth + padding) {
          this._full = true;
          // this.zone.run(() => {
          //   this.eRef.nativeElement.classList.add('full');
          // });
        }
      });
      
      this.homonym.offsetTop = this.eRef.nativeElement.offsetTop;
    });
  }

}
